import script from "./AppGroupManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AppGroupManagement.vue?vue&type=script&setup=true&lang=js"

import "./AppGroupManagement.vue?vue&type=style&index=0&id=feee77a4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feee77a4"]])

export default __exports__